module.exports = {
    "Empty": `Bo\u{15F}`
};


//# sourceMappingURL=tr-TR.main.js.map
